<template>
  <div>
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <!-- Boton para exportar Zip Expediente de contrato -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <custom-button
            class="mx-2"
            label="Expediente"
            iconText="mdi-cloud-download"
            tipo="agregar"
            v-bind="attrs"
            v-on="on"
            :loading="estaCargando"
            @click="exportar">
          </custom-button>
        </template>
        <span >Descargar Expediente</span>
      </v-tooltip>
      <!-- Boton para agregar documento a expediente -->
      <custom-button
        v-if="mixValidaScopesActions(1) && !soloLectura"
        label="Agregar Documento"
        iconText="mdi-plus"
        tipo="agregar"
        @click="agregarDocumentoExpediente">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ExpedienteToolBar',
  props: {
    estaCargando: {
      type: Boolean,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  methods: {
    exportar() {
      this.$emit('expotar');
    },
    agregarDocumentoExpediente() {
      this.$emit('agregarDocumentoExpediente');
    },
  },
};
</script>

<style lang="scss">

</style>
